import { Message } from "./entities/Message";
import Button from '@mui/material/Button';
import DoneIcon from '@mui/icons-material/Done';
import { TextareaAutosize } from '@mui/base/TextareaAutosize';
import Divider from '@mui/material/Divider';

export class IssueEntry {
  constructor(id, resolved, messages, title, onAddIssueNote, resolveIssue) {
    this.id = id;
    this.resolved = resolved;
    this.messages = messages;
    this.title = title
    this.textareaName = `textarea-issue${this.id}`;

    this.reactObj = (<div key={this.id} className="log-section">
        <Divider />
      <div className="log-section-header">
        <h2>Issue {this.id}</h2>
        {this.resolved ? <></> :
          <Button variant="contained" endIcon={<DoneIcon />} onClick={() => resolveIssue(this.id)}>Resolve</Button>
        }
      </div>
      <p style={{ verticalAlign: "bottom" }}>{this.title}</p>
      <div className="section-messages">
        {this.messages.length === 0 ?
          <p>No messages found.</p>
          :
          (<>{this.messages.map((message) => message.reactObj)}</>)}
      </div>
      <div style={{ display: "flex", flexDirection: "row", flexShrink: 0 }}>
        {this.resolved ? <></> :
          <TextareaAutosize style={{ flex: 1 }} name={this.textareaName} id={this.textareaName} placeholder="Leave a comment..."></TextareaAutosize>
        }
        {this.resolved ? <></> :
          <Button variant="contained" onClick={() => {
            let new_message = new Message(Date.now(), document.getElementsByName(this.textareaName)[0].value)
            onAddIssueNote(this.id, new_message);
            document.getElementById(this.textareaName).value = '';
          }}>Submit</Button>
        }
      </div>
    </div>);
  }

  static fromJson(issueRow, onAddIssueNote, resolveIssue) {
    let messages = Message.messagesFromJson(issueRow['messages']);
    return new IssueEntry(issueRow['id'], issueRow['resolved'], messages, issueRow['title'], onAddIssueNote, resolveIssue);
  }

  toJson() {
    let issueLogJson = { 'title': this.title, 'id': this.id, 'messages': [], 'resolved': this.resolved };
    for (let ind in this.messages) {
      issueLogJson['messages'].push(this.messages[ind].toJson());
    }
    return issueLogJson;
  }
}
